import { useQuery } from "@tanstack/react-query";
import workspaceRepository from "../../repository/WorkspaceRepository";
import {SearchType, workspacePage} from "@/model/workspace";

const getData = async (props:{
    page: number,
    size?: number,
    searchType?: SearchType,
    searchKeyword?: string,
    deleted?: boolean,
    important?: boolean,
    userId?: string
}) => {
    try {
        const { data } = await workspaceRepository.find(props);
        return data.result;
    } catch (e) {
        throw e;
    }
}

const useWorkspaces = (props: {
    page: number,
    size?: number,
    searchType?: SearchType,
    searchKeyword?: string,
    deleted?: boolean,
    important?: boolean ,
    userId?: string
}) => {
    return useQuery<workspacePage, Error>({
        queryKey: ['workspaces', props.page, props.size, props.searchType, props.searchKeyword, props.deleted, props.important, props.userId],
        queryFn: async () => getData(props),
        retry: false,
        suspense: false,
    })
}

export default useWorkspaces;